import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AdminThemeProvider } from "@/context/AdminThemeContext";
import { CustomerAuthProvider } from "@/context/CustomerAuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import CaptivePortal from "@/pages/portal/CaptivePortal";

import Login from "@/pages/admin/Login";
import ResetPassword from "@/pages/admin/ResetPassword";
import AdminLayout from "@/components/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Packages from "@/pages/admin/Packages";
import Sites from "@/pages/admin/Sites";
import Routers from "@/pages/admin/Routers";
import ProvisionSite from "@/pages/admin/ProvisionSite";
import Customers from "@/pages/admin/Customers";
import Subscriptions from "@/pages/admin/Subscriptions";
import LiveDevices from "@/pages/admin/LiveDevices";
import Transactions from "@/pages/admin/Transactions";
import Vouchers from "@/pages/admin/Vouchers";
import Reports from "@/pages/admin/Reports";
import Admins from "@/pages/admin/Admins";
import SmsOutbox from "@/pages/admin/SmsOutbox";
import Settings from "@/pages/admin/Settings";
import PppoePlans from "@/pages/admin/PppoePlans";
import PppoeLocations from "@/pages/admin/PppoeLocations";
import PppoeAccounts from "@/pages/admin/PppoeAccounts";
import PppoeAccountDetail from "@/pages/admin/PppoeAccountDetail";
import PppoeMap from "@/pages/admin/PppoeMap";
import PppoeReports from "@/pages/admin/PppoeReports";
import PppoeLegacyImport from "@/pages/admin/PppoeLegacyImport";

import CustomerLogin from "@/pages/customer/Login";
import CustomerLayout from "@/components/CustomerLayout";
import CustomerDashboard from "@/pages/customer/Dashboard";
import CustomerDevices from "@/pages/customer/Devices";
import CustomerPppoe from "@/pages/customer/Pppoe";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CustomerAuthProvider>
          <BrowserRouter>
            <Routes>
              {/* Public captive portal */}
              <Route path="/" element={<CaptivePortal />} />
              <Route path="/portal" element={<CaptivePortal />} />

              {/* Customer self-service */}
              <Route path="/customer/login" element={<CustomerLogin />} />
              <Route path="/customer" element={<CustomerLayout />}>
                <Route index element={<Navigate to="/customer/dashboard" replace />} />
                <Route path="dashboard" element={<CustomerDashboard />} />
                <Route path="devices" element={<CustomerDevices />} />
                <Route path="pppoe" element={<CustomerPppoe />} />
              </Route>

              {/* Admin auth */}
              <Route path="/admin/login" element={<AdminThemeProvider><Login /></AdminThemeProvider>} />
              <Route path="/admin/reset-password/:token" element={<ResetPassword />} />

              {/* Admin (protected) */}
              <Route path="/admin" element={<ProtectedRoute><AdminThemeProvider><AdminLayout /></AdminThemeProvider></ProtectedRoute>}>
                <Route index element={<Navigate to="/admin/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="packages" element={<Packages />} />
                <Route path="sites" element={<Sites />} />
                <Route path="routers" element={<Routers />} />
                <Route path="provision" element={<ProvisionSite />} />
                <Route path="customers" element={<Customers />} />
                <Route path="subscriptions" element={<Subscriptions />} />
                <Route path="live-devices" element={<LiveDevices />} />
                <Route path="pppoe-plans" element={<PppoePlans />} />
                <Route path="pppoe-locations" element={<PppoeLocations />} />
                <Route path="pppoe-accounts" element={<PppoeAccounts />} />
                <Route path="pppoe-accounts/import" element={<PppoeLegacyImport />} />
                <Route path="pppoe-accounts/map" element={<PppoeMap />} />
                <Route path="pppoe-accounts/reports" element={<PppoeReports />} />
                <Route path="pppoe-accounts/:id" element={<PppoeAccountDetail />} />
                <Route path="transactions" element={<Transactions />} />
                <Route path="vouchers" element={<Vouchers />} />
                <Route path="reports" element={<Reports />} />
                <Route path="admins" element={<Admins />} />
                <Route path="sms" element={<SmsOutbox />} />
                <Route path="settings" element={<Settings />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </CustomerAuthProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
